const STORAGE_KEYS = [
  'wuyetoken',
  'wuyemenusJSON',
  'menuPermissionSyncedAt',
  'buttonPermissions',
  'detail-store'
]

// 这些前缀下的缓存属于“本地图片缓存”，关闭页签/清理业务缓存时不清理，
// 仅在关闭整个浏览器后由图片缓存的会话标记自动清空。
const KEEP_STORAGE_PREFIXES = ['detail-photo-cache:']

const shouldKeepStorageKey = (key: string) =>
  KEEP_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))

export const clearAuthCache = () => {
  STORAGE_KEYS.forEach((key) => {
    if (shouldKeepStorageKey(key)) return
    sessionStorage.removeItem(key)
    localStorage.removeItem(key)
  })
}
